import Link from "next/link"
import Block from "@/components/wrappers/block"
import BlockHeader from "@/common/partials/block-header/block-header"
import styles from "./organization.module.css"
import classNames from "classnames"

export default function Organization({ block }) {
  const {
    regionHeading,
    countyHeading,
    localHeading,
    heading,
    text,
    blockGap,
    align,
    parent,
    list
  } = block.attrs
  const width = align === "inner-column" ? "column" : "full"

  if (list.length === 0) {
    return null
  }

  return (
    <Block
      block={block}
      width={width}
      gap={blockGap ?? "normal"}
      className={classNames(styles.wrapper, {
        "align-center": align === "center"
      })}>
      <BlockHeader
        heading={heading ?? null}
        text={text ?? null}
        align={align ?? "inner-column"}
      />
      <h2 className="heading">
        {parent?.type === "region" ? regionHeading : countyHeading}
      </h2>
      <ol>
        <Item item={parent} />
      </ol>
      <h2 className="heading">{localHeading}</h2>
      <ol>
        {list && list.map((item, index) => <Item key={index} item={item} />)}
      </ol>
    </Block>
  )
}

const Item = ({ item }) => {
  return item?.url ? (
    <li>
      <Link href={item.url} prefetch={false}>
        {item.name}
      </Link>
    </li>
  ) : (
    <li>{item.name}</li>
  )
}

//   return (
//     <div
//       className={classNames(
//         "organization-preview",
//         "align-" + attributes?.align
//       )}
//     >
//       <h2>{heading}</h2>
//       <ul>
//         <li>{preview.parent.name}</li>
//       </ul>
//       <h2>{attributes.localHeading}</h2>
//       <ul>
//         {preview.list.map((item, index) => (
//           <li key={index}>{item.name}</li>
//         ))}
//       </ul>
//     </div>
//   );
// };
